import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Product } from 'src/Model/Product-Interfaces';
import { ProductCardService } from '../product-card.service';
import { ApiService } from 'src/app/service/api.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-store-product',
  templateUrl: './store-product.component.html',
  styleUrls: ['./store-product.component.scss'],
})
export class StoreProductComponent implements OnInit, OnDestroy {
  @Input() products: Product[] = [];
  @Input() showDetails: boolean = false;
  productDetails: Product;
  CurrencySymbol: string;
  sub: Subscription;

  constructor(
    private productCardService: ProductCardService,
    private apiService: ApiService
  ) { }

  ngOnInit(): void {
    this.sub = this.apiService.getWebcustomer$.subscribe((res) => {
      if (res) {
        this.CurrencySymbol = res.TemplateData.CurrencySymbol || 'GBP';
      }
    });
  }

  ngOnDestroy(): void {
    if (this.sub) this.sub.unsubscribe();
  }

  showProductDetails(product: Product) {
    this.productDetails = product;
  }

  getProductModal(product: Product) {
    this.productCardService.getProductModal(product);
  }
}
